import DashboardTablePagination from 'features/dashboard/table/DashboardTablePagination'
import ColumnSelect from 'features/dashboard/table/config/ColumnSelect'
import OnOffButtons from 'features/dashboard/operation/onOff/OnOffButtons'
import DeleteButton from 'features/dashboard/operation/delete/DeleteButton'
import DownloadButton from 'features/dashboard/operation/download/DownloadButton'
import CreateCreativeButton from 'features/dashboard/operation/createCreative/CreateCreativeButton'

const CreativeTableHeader = () => (
  <div className="set_head">
    <div className="f_left">
      <div className="single_wrap">
        <CreateCreativeButton />
      </div>
      <div className="single_wrap">
        <OnOffButtons />
      </div>
      <div className="single_wrap">
        <DeleteButton />
      </div>
    </div>
    <div className="f_right">
      <div className="single_wrap">
        <DashboardTablePagination />
      </div>
      <div className="single_wrap">
        <ColumnSelect />
      </div>
      <div className="single_wrap">
        <DownloadButton />
      </div>
    </div>
  </div>
)
export default CreativeTableHeader
